import type { ReactElement, ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/design-system/components/react";

/** Details on demand: `label` shows on hover and on keyboard focus of `children`,
 * which must be a focusable element (a button, or one with tabIndex 0). A null
 * label renders `children` alone. */
export function Hint({ label, children }: { label: ReactNode | null; children: ReactElement }) {
  if (label === null) return children;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="max-w-xs border-border-strong bg-bg-2 px-2 py-1 text-[11px] text-fg">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
